import { render, staticRenderFns } from "./DGARegex.vue?vue&type=template&id=b98492de&"
import script from "./DGARegex.vue?vue&type=script&lang=js&"
export * from "./DGARegex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports